export const getScreenViewProps = () => {
    return {
        screenName: 'name',
        screenId: 'id'
    };
};
